module.exports = {"533102101":"勐卯镇","533102102":"畹町镇","533102103":"弄岛镇","533102201":"姐相乡","533102202":"户育乡","533102203":"勐秀乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533102.json
// module id = 2660
// module chunks = 0